import { BaseManualDeactivationField } from 'features/geoEvents/components/BaseManualDeactivationField';
import { useFormContext } from 'react-hook-form';

type WildfireFormValues = {
  containment: number | null;
  isFps: boolean;
  isPrescribed: boolean;
  isComplexParent: boolean;
};

type WildfireManualDeactivationFieldProps = {
  hasEvacZones: boolean;
};

export const WildfireManualDeactivationField = (
  props: WildfireManualDeactivationFieldProps,
): JSX.Element => {
  const { hasEvacZones } = props;

  const { watch } = useFormContext<WildfireFormValues>();

  const [containment, isFps, isPrescribed, isComplexParent] = watch([
    'containment',
    'isFps',
    'isPrescribed',
    'isComplexParent',
  ]);

  const fullContainment = containment === 100;

  const isDeactivationBlocked = Boolean(
    fullContainment || isPrescribed || isComplexParent,
  );

  return (
    <BaseManualDeactivationField
      hasEvacZones={hasEvacZones}
      isExternallyBlocked={isDeactivationBlocked}
      isExternallyDisabled={isFps}
    />
  );
};
